<template>
  <!-- Title -->
  <h1 class="text-3xl font-bold mb-6 text-center text-gray-800">Answers Overview</h1>

  <!-- Buttons Row for Back and Save -->
  <div class="flex justify-between mb-4">
    <button @click="cancel" class="bg-blue-500 text-white px-4 py-2 rounded">Cancel</button>
    <button @click="save" class="bg-green-500 text-white px-4 py-2 rounded">Save</button>
  </div>

  <!-- Ag-Grid for Questions and Answers -->
  <div class="ag-theme-alpine" style="width: 100%; height: 600px;">
    <ag-grid-vue
        :class="themeClass"
        style="width: 100%; height: 100%;"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :defaultColDef="defaultColDef"
        @grid-ready="onGridReady"
        :domLayout="'autoHeight'"
        :getRowHeight="getRowHeight"
        :suppressRowClickSelection="true">
    </ag-grid-vue>
  </div>
</template>

<script>
import { AgGridVue } from '@ag-grid-community/vue3'
import '@ag-grid-community/styles/ag-grid.css'
import '@ag-grid-community/styles/ag-theme-alpine.css'
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model'
import axios from '../services/axiosInstance'
import { ModuleRegistry } from '@ag-grid-community/core'

// Register the necessary AG-Grid modules
ModuleRegistry.registerModules([ClientSideRowModelModule])

export default {
  name: 'ProcessedSinglesOverview',
  components: {
    'ag-grid-vue': AgGridVue
  },
  data () {
    return {
      columnDefs: [
        {
          field: 'number',
          headerName: '#',
          maxWidth: 70
        },
        {
          field: 'question',
          headerName: 'Question',
          flex: 1,
          editable: true,
          wrapText: true,
          autoHeight: true,
          cellStyle: { 'white-space': 'pre-wrap' },
          cellEditor: 'agLargeTextCellEditor',
          cellEditorPopup: true,
          cellEditorParams: { maxLength: 500 }
        },
        {
          field: 'key',
          headerName: 'Answer Key',
          flex: 1,
          editable: true,
          wrapText: true,
          autoHeight: true,
          cellStyle: { 'white-space': 'pre-wrap' },
          cellEditor: 'agLargeTextCellEditor',
          cellEditorPopup: true,
          cellEditorParams: { maxLength: 500 }
        },
        {
          field: 'points',
          headerName: 'Points',
          maxWidth: 100,
          editable: true,
          type: 'numericColumn',
          valueParser: params => parseFloat(params.newValue) || 0
        }
      ],
      defaultColDef: {
        resizable: true,
        sortable: true,
        filter: true
      },
      rowData: null,
      themeClass: 'ag-theme-alpine',
      gridApi: null,
      gridColumnApi: null
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      const testId = this.$route.params.id
      axios.get(`/tests/${testId}/answers/overview`)
        .then(response => {
          // Process data to replace '\\n' with '\n'
          this.rowData = response.data.map(item => {
            return {
              ...item,
              question: item.question ? item.question.replace(/\\n/g, '\n') : '',
              key: item.key ? item.key.replace(/\\n/g, '\n') : ''
            }
          })
          console.log('Processed Data:', this.rowData)
        })
        .catch(error => {
          console.error('Error fetching answers overview:', error)
        })
    },
    onGridReady (params) {
      this.gridApi = params.api
      this.gridColumnApi = params.columnApi
      this.gridApi.sizeColumnsToFit()
    },
    getRowHeight (params) {
      const questionLines = params.data.question ? params.data.question.split('\n').length : 1
      const keyLines = params.data.key ? params.data.key.split('\n').length : 1
      const maxLines = Math.max(questionLines, keyLines)
      const baseHeight = 28 // Base height per row in pixels
      const lineHeight = 20 // Approximate height per line in pixels
      return baseHeight + (maxLines * lineHeight)
    },
    cancel () {
      const testId = this.$route.params.id
      this.$router.push(`/tests/${testId}`)
    },
    save () {
      const testId = this.$route.params.id
      console.info('Saving data...')

      const rowDataToSend = []
      if (this.gridApi) {
        this.gridApi.forEachNode(node => {
          const singleDto = {
            number: node.data.number,
            question: node.data.question,
            answer: node.data.key,
            category: node.data.category,
            points: parseFloat(node.data.points) || 0
          }
          rowDataToSend.push(singleDto)
        })
      }

      axios.put(`/tests/${testId}/singles`, rowDataToSend)
        .then(() => {
          console.info('Data successfully saved')
          this.$router.push(`/tests/${testId}`)
        })
        .catch(error => {
          console.error('Error saving data:', error)
        })
    }
  }
}
</script>

<style scoped>
button {
  outline: none;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.ag-theme-alpine {
  width: 100%;
  height: 600px; /* Example fixed height */
}

.ag-cell {
  white-space: pre-wrap; /* Preserve newlines and wrap text */
}
</style>
